// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility Utilities */

/* Skip link for keyboard users */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--text-primary);
  color: var(--bg-main);
  padding: 8px;
  z-index: 100;
  transition: top 0.3s;
}

.skip-link:focus {
  top: 0;
}

/* Focus visible for all interactive elements */
:focus-visible {
  outline: 2px solid var(--text-muted);
  outline-offset: 2px;
}

/* Reduce motion for users who prefer it */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/utils/accessibility.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,MAAM;AACR;;AAEA,+CAA+C;AAC/C;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* Accessibility Utilities */\n\n/* Skip link for keyboard users */\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: var(--text-primary);\n  color: var(--bg-main);\n  padding: 8px;\n  z-index: 100;\n  transition: top 0.3s;\n}\n\n.skip-link:focus {\n  top: 0;\n}\n\n/* Focus visible for all interactive elements */\n:focus-visible {\n  outline: 2px solid var(--text-muted);\n  outline-offset: 2px;\n}\n\n/* Reduce motion for users who prefer it */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
